/*
 *   Copyright (c) 2021 RCUBE PLANET PVT LTD
 *   All rights reserved.
 */
import React from 'react'
import * as Icon from 'react-feather'

const navigationConfig = [
  {
    id: 'home',
    title: 'Dashboard',
    type: 'item',
    icon: <Icon.Home size={20} />,
    navLink: '/',
  },
  {
    id: 'order',
    title: 'Orders',
    type: 'item',
    icon: <Icon.Package size={20} />,
    navLink: '/admin/order/list',
  },
  {
    id: 'Payments',
    title: 'Payments',
    type: 'item',
    icon: <Icon.DollarSign size={20} />,
    navLink: '/admin/payment/list',
  },
  {
    id: 'user',
    title: 'Users',
    type: 'collapse',
    icon: <Icon.User size={20} />,

    children: [
      {
        id: 'userList',
        title: 'View Users ',
        type: 'item',
        icon: <Icon.Circle size={10} />,
        navLink: '/admin/user/list',
        permissions: ['admin'],
      },

      {
        id: 'kycList',
        title: 'Users KYC',
        type: 'item',
        icon: <Icon.Circle size={10} />,
        navLink: '/admin/user/kyc/list',
        permissions: ['admin'],
      },
      {
        id: 'fullTicketList',
        title: 'KYC Docs Ticket',
        type: 'item',
        icon: <Icon.Circle size={10} />,
        navLink: '/admin/user/kyc/full-ticket/list',
        permissions: ['admin'],
      },
    ],
  },

  {
    id: 'voucher',
    title: 'Voucher',
    type: 'item',
    icon: <Icon.Gift size={20} />,
    navLink: '/admin/wallet/voucher/list',
    permissions: ['admin'],
  },
  {
    id: 'Banners',
    title: 'Banners',
    type: 'item',
    icon: <Icon.Image size={20} />,
    navLink: '/admin/static/data/coupon/banner/list',
    permissions: ['admin'],
  },
  {
    id: 'Stores',
    title: 'Stores',
    type: 'item',
    icon: <Icon.ShoppingBag size={20} />,
    navLink: '/admin/static/data/coupon/store/list',
    permissions: ['admin'],
  },
  {
    id: 'Categories',
    title: 'Categories',
    type: 'item',
    icon: <Icon.Grid size={20} />,
    navLink: '/admin/static/data/coupon/category/list',
    permissions: ['admin'],
  },
  {
    id: 'Coupon',
    title: 'All Coupons',
    type: 'item',
    icon: <Icon.CreditCard size={20} />,
    navLink: '/admin/static/data/coupon/list',
    permissions: ['admin'],
  },

  {
    id: 'Banks',
    title: 'Banks',
    icon: <Icon.Briefcase size={20} />,
    type: 'item',
    navLink: '/admin/static/data/coupon/bank/list',
    permissions: ['admin'],
  },
  {
    id: 'Tags',
    title: 'Tags',
    type: 'item',
    icon: <Icon.Tag size={20} />,
    navLink: '/admin/static/data/coupon/tag/list',
    permissions: ['admin'],
  },

  // {
  //   id: 'coupon-report',
  //   title: 'Coupon report',
  //   type: 'item',
  //   icon: <Icon.Circle size={10} />,
  //   navLink: '/admin/static/data/coupon/report/list',
  //   permissions: ['admin'],
  // },
  // {
  //   id: 'coupon-comment',
  //   title: 'Coupon comment',
  //   type: 'item',
  //   icon: <Icon.Circle size={10} />,
  //   navLink: '/admin/static/data/coupon/comment/list',
  //   permissions: ['admin'],
  // },
  // {
  //   id: 'coupon-store-review',
  //   title: 'Coupon-store-review',
  //   type: 'item',
  //   icon: <Icon.Circle size={10} />,
  //   navLink: '/admin/static/data/coupon/store/review/list',
  //   permissions: ['admin'],
  // },

  {
    id: 'staff',
    title: 'Staff',
    type: 'item',
    icon: <Icon.Users size={20} />,
    navLink: '/admin/staff/list',
    permissions: ['admin', 'editor'],
  },
  // {
  //   id: 'Finance',
  //   title: 'Finance Report ',
  //   type: 'item',
  //   icon: <Icon.DollarSign size={20} />,
  //   navLink: '/admin/finance/report',
  // },
  {
    id: 'logout',
    title: 'Log Out',
    type: 'item',
    icon: <Icon.LogOut size={20} />,
    navLink: '/logout',
  },
]

export default navigationConfig
